import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";

import { updateGame } from "../../actions/index";
import { minLength2, required } from "../../constants/ValidationRules";
import { DifficultyLevelChoice } from "./DifficultyLevelChoice";
import {
    DURATION,
    LOC_NAME,
    TITLE,
    SHORT_TITLE,
    DIFFICULTY
} from "../../constants/Game";

import { renderField } from "../common_page_elements";

import './UpdateIntro.css'
import "../../global.css"

/**
 * Goes inside a modal to update just the location name/description.
 */
class UpdateDetails extends Component {
    constructor(props) {
        super(props);

        const difficultyLevel = props.game ? props.game[DIFFICULTY] : null;

        this.state = {
            difficultyLevel,
            isFetching: false
        };

        this.onDifficultyChange = this.onDifficultyChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onDifficultyChange(event, newValue) {

        this.setState( { difficultyLevel: newValue });
    }

    onSubmit(values) {

        this.setState( { isFetching: true });

        const { game, closeModalCallback } = this.props;

        this.props.updateGame(game.id, game.isPublic, values, () => {

                closeModalCallback();
        });
    }

    render() {
        const { handleSubmit } = this.props;

        const noTopPadding = {
            paddingTop: '0px'
        };

        // onDateChange, onEventHuntChecked, dateValue

        return (
            <div>
                <button
                    style={noTopPadding}
                    className="btn btn-link pull-right"
                    onClick={this.props.closeModalCallback}>

                    X
                </button>
                <h4 className="location-update-dialog-buffer bottom-margin"> Update Hunt Details </h4>
                <p> A distinctive title, descriptive location, and accurate difficulty level.
                </p>

                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <div className="col-9">
                        <div>
                            <div>
                                <Field
                                    name={TITLE}
                                    id="title"
                                    type="text"
                                    isRow="true"
                                    component={renderField}
                                    label="Title"
                                />
                                <Field
                                   name={LOC_NAME}
                                   component={ renderField }
                                   type="text"
                                   isRow="true"
                                   validate={[required, minLength2]}
                                   label="Location"
                                />
                                <DifficultyLevelChoice
                                    isShort={true}
                                    difficultyLevel={this.state.difficultyLevel}
                                    onChange={this.onDifficultyChange}
                                />
                            </div>
                        </div>
                        <div>
                            <button type="submit">
                                Save
                            </button>
                        </div>
                    </div>
                </form>

                {this.state.isFetching && <div className="loader"/>}
            </div>
        )
    }
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
UpdateDetails = reduxForm({
    form: 'UpdateLocNameForm' // a unique identifier for this form
})(
    connect(null, { updateGame }
    )(UpdateDetails));

// You have to connect() to any reducers that you wish to connect to yourself

UpdateDetails = connect(
    state => {
        const selectedGame = state.games[state.selectedGameId];

        return {
            initialValues: {
                [TITLE]: selectedGame[TITLE],
                [SHORT_TITLE]: selectedGame[SHORT_TITLE],
                [LOC_NAME]: selectedGame[LOC_NAME],
                [DURATION]: selectedGame[DURATION]
            },
            game: selectedGame
        }
    }
)(UpdateDetails);

export default UpdateDetails;



// WEBPACK FOOTER //
// ./src/components/huntcomponents/UpdateDetails.js